module.exports = __webpack_public_path__ + "img/template_placeholder_red@2x.35c737a.png";